module.exports = __webpack_public_path__ + "308d50ff536a132fdf3b23e8002fc67a.MP3";